import { render, staticRenderFns } from "./CartAddressItem.vue?vue&type=template&id=be812d18&"
import script from "./CartAddressItem.vue?vue&type=script&lang=js&"
export * from "./CartAddressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports